export default {
      id: "maintenance_fuel-usage",
      viewBox: "0 0 25 27",
      url: __webpack_public_path__ + "img/icons.svg#maintenance_fuel",
      toString: function () {
        return this.url;
      }
    }